export default __webpack_public_path__ + "static/media/success.8281e284.jpeg";